export default __webpack_public_path__ + "static/media/cases2@2x.9d87dda9.jpg";